export const ROLE_CONTRACTOR = 'contractor' as const;
export const ROLE_EMPLOYEE = 'employee' as const;
export const ROLE_MANAGER = 'manager' as const;
export const ROLE_LEADER = 'leader' as const;
export const ROLE_HR = 'hr' as const;
export const ROLE_ADMIN = 'admin' as const;

export type UserRole =
  typeof ROLE_CONTRACTOR | typeof ROLE_EMPLOYEE | typeof ROLE_MANAGER | typeof ROLE_LEADER | typeof ROLE_HR | typeof ROLE_ADMIN;
